export const session = {
  invoke: {
    src: 'watchSession',
  },
  initial: 'initializing',
  states: {
    initializing: {
      on: {
        SESSION_STATE_LOGGED_IN: {
          target: 'userLoggedIn',
          actions: [
            {
              type: 'save',
              data: {
                user: '$event.data',
                sessionResolved: true,
              },
              meta: {
                selectors: ['$action.data.user'],
              },
            },
          ],
        },
        SESSION_STATE_LOGGED_OUT: {
          target: 'userLoggedOut',
          actions: [
            {
              type: 'save',
              data: {
                user: '$event.data',
                sessionResolved: true,
              },
              meta: {
                selectors: ['$action.data.user'],
              },
            },
          ],
        },
      },
    },
    userLoggedOut: {
      entry: ['renderBingoGames'],
      on: {
        SESSION_STATE_LOGGED_IN: {
          target: 'userLoggedIn',
          actions: [
            {
              type: 'save',
              data: {
                user: '$event.data',
              },
              meta: {
                selectors: ['$action.data.user'],
              },
            },
          ],
        },
      },
    },
    userLoggedIn: {
      type: 'parallel',
      entry: 'renderBingoGames',
      states: {
        manageUserRelatedContent: {
          entry: 'updateUserTrackingInfo',
          initial: 'fetchPageForLoggedInUser',
          states: {
            fetchPageForLoggedInUser: {
              always: [
                {
                  target: 'fetchAuthToken',
                  cond: 'isAppInitilaized_InternalTokenVariant',
                },
                {
                  target: 'idle',
                },
              ],
            },
            fetchAuthToken: {
              invoke: {
                src: 'fetchAuthToken',
                onDone: [
                  {
                    target: 'updateAuthData',
                    actions: ['saveAuthToken'],
                  },
                ],
              },
            },
            updateAuthData: {
              always: [
                {
                  target: 'idle',
                  actions: [
                    { type: 'save', data: { initialRequest: true } },
                    'layout_changePageId',
                  ],
                  cond: 'areAnySavedSegments',
                },
                {
                  target: 'idle',
                  actions: [
                    'categories_refetch',
                    'categories_reload',
                    'layout_reload',
                    'layout_changePageId',
                  ],
                  cond: 'isDifferentCurrency',
                },
                {
                  target: 'idle',
                  actions: ['layout_reload', 'layout_changePageId'],
                  cond: 'arePersonalizedBannersAvailable',
                },
                {
                  target: 'idle',
                  actions: [
                    'layout_reload',
                    'layout_changePageId',
                    'saveInfoAccountInfo',
                    'trackPendingAccountEvents',
                  ],
                },
              ],
            },
            idle: {
              entry: ['fetchRecentlyPlayed'],
              invoke: [{ src: 'watchSessionTokenExpirationTime' }],
              initial: 'idle',
              states: {
                idle: {
                  on: {
                    REFRESH_SESSION_TOKEN: [
                      {
                        actions: ['fetchRefreshedSessionToken'],
                        cond: 'isInternalAuthTokenVariant',
                      },
                      {
                        actions: ['saveRefreshedAuthToken'],
                      },
                    ],
                    SESSION_STATE_LOGGED_OUT: [
                      {
                        cond: 'currentlyOnRecentlyPlayedPage',
                        target: '#root.main.session.userLoggedOut',
                        actions: [
                          {
                            type: 'savePreviousUser',
                          },
                          {
                            type: 'save',
                            data: {
                              user: '$event.data',
                            },
                            meta: {
                              selectors: ['$action.data.user'],
                            },
                          },
                          'rp_rerender',
                        ],
                      },
                      {
                        cond: 'arePersonalizedBannersAvailable',
                        target: '#root.main.session.userLoggedOut',
                        actions: [
                          {
                            type: 'savePreviousUser',
                          },
                          {
                            type: 'save',
                            data: {
                              user: '$event.data',
                            },
                            meta: {
                              selectors: ['$action.data.user'],
                            },
                          },
                          'layout_changePageId',
                          'rp_rerender',
                        ],
                      },
                      {
                        cond: 'isDifferentCurrency',
                        target: '#root.main.session.userLoggedOut',
                        actions: [
                          {
                            type: 'savePreviousUser',
                          },
                          {
                            type: 'save',
                            data: {
                              user: '$event.data',
                            },
                            meta: {
                              selectors: ['$action.data.user'],
                            },
                          },
                          'layout_changePageId',
                          'rp_rerender',
                        ],
                      },
                      {
                        target: '#root.main.session.userLoggedOut',
                        actions: [
                          {
                            type: 'savePreviousUser',
                          },
                          {
                            type: 'save',
                            data: {
                              user: '$event.data',
                            },
                            meta: {
                              selectors: ['$action.data.user'],
                            },
                          },
                          'layout_reload',
                          'rp_rerender',
                        ],
                      },
                    ],
                  },
                },
              },
            },
          },
        },
        managePhrases: {
          initial: 'idle',
          states: {
            idle: {
              always: [
                {
                  target: 'addPendingPhraseToRecentPhrases',
                  cond: 'isPhrasePendingToAddToRecentPhrases',
                },
              ],
            },
            addPendingPhraseToRecentPhrases: {
              invoke: {
                src: 'fetchRecentPhrases',
                onDone: {
                  actions: [
                    {
                      type: 'save',
                      data: {
                        recentPhrases: '$event.data.recentPhrases',
                      },
                      meta: {
                        selectors: ['$action.data.recentPhrases'],
                      },
                    },
                    {
                      type: 'updatePhrases',
                    },
                    {
                      type: 'savePhrase',
                    },
                  ],
                },
              },
            },
          },
        },
      },
    },
  },
};
